export default __webpack_public_path__ + "static/media/footerlogo.e9cdf269.png";